import { render, staticRenderFns } from "./StatCallCenter.vue?vue&type=template&id=d5477b1e&"
import script from "./StatCallCenter.vue?vue&type=script&lang=ts&"
export * from "./StatCallCenter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports